export const RESEND_ACTIVATE_LINK_FAILURE = 'RESEND_ACTIVATE_LINK_FAILURE';

export const resendActivateLinkFailure = error => ({
    type: RESEND_ACTIVATE_LINK_FAILURE,
    payload: error,
    error: true,
});
